import { Button } from 'antd';
import React from 'react';

const ExternalLinkButton = ({ label, link, onClick }) => {
    return (
        <Button style={{ padding: 25, fontWeight: "bold", width: "100%" }} className='external-link-button'
            onClick={() => { onClick ? onClick() : window.open(link, "_blank") }}>{label}</Button>
    );
}

export default ExternalLinkButton;